import React, { useCallback, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import axios from "axios";
import { IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import {
  Box,
  Button,
  Container,
  TextField,
  Grid,
  FormControlLabel,
  Typography,
  Tabs,
  Tab,
  CircularProgress,
} from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { DataGrid } from "@mui/x-data-grid";
import { TabContext, TabPanel } from "@mui/lab";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import ReactSelect from "react-select";
import { useSelector } from "react-redux";
import md5 from "md5";

const UserRegistration = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const _userId = location.state?.uid;
  const PracticeId = location.state?.PracticeId;

  const token = localStorage.getItem("Thyra_Token");
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  const [tabValue, setTabValue] = useState("userInfo");
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageBase64, setImageBase64] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formError, setFormError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [userName, setUserName] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [practiceId, setPracticeId] = useState("");
  const [loadingPractices, setLoadingPractices] = useState(false);

  const stateOptions = [
    { value: "", label: "Select..." },
    { value: "AL", label: "Alabama" },
    { value: "AK", label: "Alaska" },
    { value: "AZ", label: "Arizona" },
    { value: "AR", label: "Arkansas" },
    { value: "CA", label: "California" },
    { value: "CO", label: "Colorado" },
    { value: "CT", label: "Connecticut" },
    { value: "DE", label: "Delaware" },
    { value: "DC", label: "District of Columbia" },
    { value: "FL", label: "Florida" },
    { value: "GA", label: "Georgia" },
    { value: "HI", label: "Hawaii" },
    { value: "ID", label: "Idaho" },
    { value: "IL", label: "Illinois" },
    { value: "IN", label: "Indiana" },
    { value: "IA", label: "Iowa" },
    { value: "KS", label: "Kansas" },
    { value: "KY", label: "Kentucky" },
    { value: "LA", label: "Louisiana" },
    { value: "ME", label: "Maine" },
    { value: "MD", label: "Maryland" },
    { value: "MA", label: "Massachusetts" },
    { value: "MI", label: "Michigan" },
    { value: "MN", label: "Minnesota" },
    { value: "MS", label: "Mississippi" },
    { value: "MO", label: "Missouri" },
    { value: "MT", label: "Montana" },
    { value: "NE", label: "Nebraska" },
    { value: "NV", label: "Nevada" },
    { value: "NH", label: "New Hampshire" },
    { value: "NJ", label: "New Jersey" },
    { value: "NM", label: "New Mexico" },
    { value: "NY", label: "New York" },
    { value: "NC", label: "North Carolina" },
    { value: "ND", label: "North Dakota" },
    { value: "OH", label: "Ohio" },
    { value: "OK", label: "Oklahoma" },
    { value: "OR", label: "Oregon" },
    { value: "PA", label: "Pennsylvania" },
    { value: "RI", label: "Rhode Island" },
    { value: "SC", label: "South Carolina" },
    { value: "SD", label: "South Dakota" },
    { value: "TN", label: "Tennessee" },
    { value: "TX", label: "Texas" },
    { value: "UT", label: "Utah" },
    { value: "VT", label: "Vermont" },
    { value: "VA", label: "Virginia" },
    { value: "WA", label: "Washington" },
    { value: "WV", label: "West Virginia" },
    { value: "WI", label: "Wisconsin" },
    { value: "WY", label: "Wyoming" },
  ];

  const validationSchema = Yup.object().shape({
    id: Yup.number().default(0),
    fullName: Yup.string().required("Full Name is required"),
    userName: Yup.string().required("User Name is required"),
    email: Yup.string().email("Invalid email format").required("Email is required"),
    password: Yup.string().min(3, "Password must be at least 3 characters").required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
    userType: Yup.string().required("User Type is required"),
    address: Yup.string().required("Address is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string()
      .required("State is required")
      .oneOf(
        stateOptions.filter((option) => option.value !== "").map((option) => option.value),
        "Invalid state"
      ),
    zipCode: Yup.string().required("Zip Code is required"),
    defaultpracticeId: Yup.number().required("Default Practice is required"),
    dob: Yup.date().required("Date of Birth is required").nullable(),
    gender: Yup.string().required("Gender is required"),
    contactNo: Yup.string().nullable(),
    street: Yup.string().nullable(),
    provider_id: Yup.number().nullable(),
    defaultFacilityId: Yup.number().required("Default Facility is required"),
    roleId: Yup.number().default(0),
    practices: Yup.number().default(0),
  });

  const defValues = {
    id: _userId || 0,
    fullName: "",
    userName: "",
    email: "",
    password: "",
    confirmPassword: "",
    userType: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    defaultpracticeId: PracticeId || 0,
    dob: null,
    gender: "",
    contactNo: "",
    street: "",
    resetPassword: false,
    isSuperUser: false,
    isStaff: false,
    psychastricPhysician: false,
    isVerified: false,
    mobileLogin: false,
    provider_id: 0,
    defaultFacilityId: 0,
    roleId: 0,
    practices: 0,
  };

  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    watch,
    formState: { errors },
    trigger,
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    resolver: yupResolver(validationSchema),
    defaultValues: defValues,
  });

  const [practiceIdError, setPracticeIdError] = useState(false);
  const [providerIdError, setProviderIdError] = useState(false);
  const [userPractice, setUserPractice] = useState(0);
  const [userFacility, setUserFacility] = useState(0);
  const [practicesList, setPracticesList] = useState([]);
  const [allPracticesList, setAllPracticesList] = useState([]);
  const [duplicateError, setDuplicateError] = useState(false);
  const [userProvider, setUserProvider] = useState(0);
  const [providers, setProviders] = useState([]);
  const [rows, setRows] = useState([]);
  const [roles, setRoles] = useState([]);
  const [resetPassword, setResetPassword] = useState(getValues("resetPassword") || false);
  const [isSuperUser, setIsSuperUser] = useState(getValues("isSuperUser") || false);
  const [isStaff, setIsStaff] = useState(getValues("isStaff") || false);
  const [psychastricPhysician, setPsychastricPhysician] = useState(getValues("psychastricPhysician") || false);
  const [isVerified, setIsVerified] = useState(getValues("isVerified") || false);
  const [mobileLogin, setMobileLogin] = useState(getValues("mobileLogin") || false);
  const facilitieslist = useSelector((state) => state.facilities?.facilities || []);
  const providerlist = useSelector((state) => state.providers?.providers || []);

  const facilityOptions = [
    { value: 0, label: "Select..." },
    ...facilitieslist.map((facility) => ({
      value: facility.id,
      label: facility.name,
    })),
  ];



  const practiceOptions = [
    { value: 0, label: "Select..." },
    ...allPracticesList.map((prac) => ({
      value: prac.value,
      label: prac.label,
    })),
  ];

  const defaultPracticeOptions = [
    { value: 0, label: "Select..." },
    ...practicesList.map((prac) => ({
      value: prac.id,
      label: prac.PracticeName,
    })),
  ];

  const providerOptions = providers.map((prov) => ({
    value: prov.value,
    label: prov.label,
  }));

  const genderOptions = [
    { value: "", label: "Select..." },
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];



  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "practiceName", headerName: "Practice", width: 150 },
    { field: "providerName", headerName: "Provider", width: 150 },
  ];

  const gridRowStyle = {
    "& .MuiDataGrid-columnHeaders": {
      bgcolor: "#F5F7F9",
      color: "#2B7B7E",
      fontWeight: "bold",
    },
    "& .MuiDataGrid-cell": {
      borderBottom: "1px solid #E0E0E0",
    },
    "& .MuiDataGrid-footerContainer": {
      bgcolor: "#F5F7F9",
    },
  };


  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Module/GetRoles`, { headers })
      .then((response) => {
        setRoles(response || []);
      })
      .catch((error) => {
        console.error("Error fetching roles:", error);
      });
  }, []);


  const userTypeOptions = [
    { value: "", label: "Select..." },
    ...roles.map((role) => ({
      value: role.name,
      label: role.name,
    })),
  ];

  useEffect(() => {
    setValue("resetPassword", resetPassword);
  }, [resetPassword, setValue]);

  useEffect(() => {
    setValue("isSuperUser", isSuperUser);
  }, [isSuperUser, setValue]);

  useEffect(() => {
    setValue("isStaff", isStaff);
  }, [isStaff, setValue]);

  useEffect(() => {
    setValue("psychastricPhysician", psychastricPhysician);
  }, [psychastricPhysician, setValue]);

  useEffect(() => {
    setValue("isVerified", isVerified);
  }, [isVerified, setValue]);

  useEffect(() => {
    setValue("mobileLogin", mobileLogin);
  }, [mobileLogin, setValue]);

  const handleCheckboxChange = (fieldName, isChecked) => {
    console.log(`Checkbox for ${fieldName} is now ${isChecked ? "checked" : "unchecked"}`);

    // Update local state based on fieldName
    switch (fieldName) {
      case "resetPassword":
        setResetPassword(isChecked);
        break;
      case "isSuperUser":
        setIsSuperUser(isChecked);
        break;
      case "isStaff":
        setIsStaff(isChecked);
        break;
      case "psychastricPhysician":
        setPsychastricPhysician(isChecked);
        break;
      case "isVerified":
        setIsVerified(isChecked);
        break;
      case "mobileLogin":
        setMobileLogin(isChecked);
        break;
      default:
        break;
    }

    // Sync with react-hook-form
    setValue(fieldName, isChecked);
  };

  const handleCancel = useCallback(() => {
    navigate("/User");
  }, [navigate]);

  const handleUserPractice = (event) => {
    event.preventDefault();
    if (!userPractice || userPractice <= 0) {
      setPracticeIdError(true);
      return;
    }
    if (!userProvider || userProvider <= 0) {
      setProviderIdError(true);
      return;
    }

    const duplicate = rows.filter((row) => row.practiceId === userPractice);
    if (duplicate.length > 0) {
      setDuplicateError(true);
      return;
    }

    const postData = {
      UserEmail: emailAddress,
      facilityId: userFacility,
      practiceId: userPractice,
      providerId: userProvider,
    };

    setSubmitting(true);
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/User/addUserPractices`,
        postData,
        { headers }
      )
      .then(() => {
        setSubmitting(false);
        setRefresh(!refresh);
        setPracticeIdError(false);
        setProviderIdError(false);
        setDuplicateError(false);
      })
      .catch((error) => {
        setSubmitting(false);
        console.error("Error:", error);
      });
  };

  const onSubmit = async (data) => {
    const isFormValid = await trigger([
      "fullName",
      "userName",
      "email",
      "password",
      "confirmPassword",
      "userType",
      "address",
      "city",
      "state",
      "zipCode",
      "defaultpracticeId",
      "dob",
      "gender",
      "defaultFacilityId",
    ]);

    if (!isFormValid) {
      setFormError("Please fill all required fields correctly.");
      return;
    }
  

    const selectedRole = roles.find((role) => role.name === data.userType);
  const roleId = selectedRole ? selectedRole.id : 0;

    const postData = {
      ...data,
      password: md5(data.password), // Hash password
      confirmPassword: md5(data.confirmPassword), // Hash confirmPassword
      roleId,
      profilePhoto: imageBase64,
      facilityId: userFacility || 0,
    };

    setIsSubmitting(true);
    setFormError("");
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/User/userRegistration`,
        postData,
        { headers }
      );
      setIsSubmitting(false);
      navigate("/User");
    } catch (error) {
      setFormError(`Error: ${error.message}`);
      setIsSubmitting(false);
    }
  };



  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        setImageBase64(reader.result); // Store Base64 string
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    setImagePreview(null);
    setImageBase64(null);
  };

  useEffect(() => {
    if (_userId) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/User/getUserById?id=${_userId}`, { headers })
        .then((response) => {
          const data = response;
          const formattedDob = data.dob ? new Date(data.dob).toISOString().split("T")[0] : null;
          setValue("id", data.id || 0);
          setValue("provider_id", data.provider_id || 0);
          setValue("fullName", data.fullName || "");
          setValue("userName", data.userName || "");
          setValue("email", data.email || "");
          setValue("password", data.password || "");
          setValue("confirmPassword", data.password || "");
          setValue("resetPassword", data.resetPassword || false);
          setValue("dob", formattedDob || null);
          setValue("userType", data.userType || "");
          setValue("gender", data.gender || "");
          setValue("street", data.street || "");
          setValue("address", data.address || "");
          setValue("city", data.city || "");
          setValue(
            "state",
            stateOptions.some((opt) => opt.value === data.state) ? data.state : ""
          );
          setValue("zipCode", data.zipCode || "");
          setValue("contactNo", data.contactNo || "");
          setValue("defaultpracticeId", data.defaultpracticeId || 0);
          setValue("defaultFacilityId", data.defaultFacilityId || 0);
          setValue("practices", data.practices || 0);
          setValue("isVerified", data.isVerified || false);
          setValue("roleId", data.roleId || 0);
          setValue("isSuperUser", data.isSuperUser || false);
          setValue("isStaff", data.isStaff || false);
          setValue("psychastricPhysician", data.psychastricPhysician || false);
          setValue("mobileLogin", data.mobileLogin || false);
          setUserName(data.userName || "");
          setEmailAddress(data.email || "");
          setPracticeId(data.defaultpracticeId || "");
          setResetPassword(data.resetPassword || false);
          setIsSuperUser(data.isSuperUser || false);
          setIsStaff(data.isStaff || false);
          setPsychastricPhysician(data.psychastricPhysician || false);
          setIsVerified(data.isVerified || false);
          setMobileLogin(data.mobileLogin || false);
          if (data.profilePhoto) {
            setImagePreview(data.profilePhoto);
            setImageBase64(data.profilePhoto);
          }
        })
        .catch((error) => console.error("Error fetching user:", error));
    }
  }, [_userId, setValue]);


  useEffect(() => {
    setLoadingPractices(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/Practices/GetPracticesList`, { headers })
      .then((response) => {
        const formattedPractices = response.map((prac) => ({
          value: prac.id,
          label: prac.PracticeName,
        }));
        setAllPracticesList(formattedPractices);
        setLoadingPractices(false);
      })
      .catch((error) => {
        console.error("Error fetching practices:", error);
        setLoadingPractices(false);
      });
  }, []);


  useEffect(() => {
    if (emailAddress) {
      setLoadingPractices(true);
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/User/getUserPractices?userEmail=${emailAddress}`,
          { headers }
        )
        .then((response) => {
          const formattedPractices = response.map((row) => ({
            id: row.practiceId,
            PracticeName: row.practiceName,
          }));
          setPracticesList(formattedPractices);
          const formattedRows = response.map((row) => ({
            id: row.id, // Use unique id from API for DataGrid
            practiceId: row.practiceId,
            practiceName: row.practiceName,
            providerName: row.providerName,
          }));
          setRows(formattedRows);
          setLoadingPractices(false);
        })
        .catch((error) => {
          console.error("Error fetching user practices:", error);
          setLoadingPractices(false);
        });
    }
  }, [emailAddress, refresh]);



  console.log("facilities", facilitieslist);
  useEffect(() => {
    if (practiceId) {
      console.log("providerslist", providerlist);
      const prov = providerlist.map((field) => ({
        label: field.firstName,
        value: field.id,
      }));
      setProviders(prov);
    }
  }, [practiceId, setValue]);

  return (
    <Container sx={{ pt: 10, pb: 4, maxWidth: "lg" }}>
      <Box sx={{ maxWidth: "1000px", mx: "auto" }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", color: "#2B7B7E", mb: 4 }}
        >
          User Registration
        </Typography>
        {formError && (
          <Typography color="error" sx={{ mb: 3, fontSize: "0.875rem" }}>
            {formError}
          </Typography>
        )}
        <TabContext value={tabValue}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "#E0E0E0",
              mb: 4,
              bgcolor: "#F5F7F9",
              borderRadius: "12px",
              p: 1,
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              sx={{
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontWeight: "bold",
                  color: "#77A2A7",
                  fontSize: "0.95rem",
                  "&.Mui-selected": {
                    color: "#2B7B7E",
                  },
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "#2B7B7E",
                },
              }}
            >
              <Tab label="User Info" value="userInfo" />
              <Tab label="Practices" value="practices" />
            </Tabs>
          </Box>

          <Box
            component="form"
            onSubmit={handleSubmit(onSubmit)}
            sx={{
              bgcolor: "#FFFFFF",
              p: 4,
              borderRadius: "12px",
              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
            }}
          >
            <TabPanel value="userInfo" sx={{ p: 0 }}>
              <Grid container spacing={4}>
                {/* Profile Photo Card */}
                <Grid item xs={12} sm={3}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      border: "1px solid #E0E0E0",
                      borderRadius: "12px",
                      p: 3,
                      bgcolor: "#FFFFFF",
                      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
                      width: "200px",
                      mx: "auto",
                    }}
                  >
                    <Button
                      component="label"
                      sx={{
                        bgcolor: imagePreview ? "transparent" : "#2B7B7E",
                        color: imagePreview ? "transparent" : "#FFFFFF",
                        borderRadius: "50%",
                        width: 80,
                        height: 80,
                        p: 0,
                        overflow: "hidden",
                        "&:hover": { bgcolor: imagePreview ? "transparent" : "#195C5F" },
                      }}
                    >
                      {imagePreview ? (
                        <img
                          src={imagePreview}
                          alt="Profile Preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <CameraAltIcon sx={{ fontSize: 40 }} />
                      )}
                      <input
                        type="file"
                        hidden
                        onChange={handleFileChange}
                        accept="image/*"
                      />
                    </Button>
                    {selectedFile && (
                      <Box sx={{ mt: 2, textAlign: "center", display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography
                          sx={{
                            fontSize: "0.875rem",
                            color: "#77A2A7",
                            maxWidth: "120px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {selectedFile.name}
                        </Typography>
                        <IconButton
                          onClick={handleRemoveFile}
                          sx={{
                            color: "#D32F2F",
                            "&:hover": { bgcolor: "#EAF1F5" },
                            borderRadius: "50%",
                            p: 0.5,
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    )}
                  </Box>
                </Grid>

                {/* Form Fields Card */}
                <Grid item xs={12} sm={9}>
                  {/* Personal Information Card */}
                  <Box
                    sx={{
                      bgcolor: "#FFFFFF",
                      p: 3,
                      borderRadius: "12px",
                      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
                      mb: 4,
                    }}
                  >
                    <Typography
                      sx={{ fontWeight: "bold", color: "#2B7B7E", mb: 3 }}
                    >
                      Personal Information
                    </Typography>
                    <Grid container spacing={2}>


                      <Grid item xs={6} md={3}>
                        <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>
                          Full Name *
                        </Typography>
                        <Controller
                          name="fullName"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              fullWidth
                              placeholder="Enter full name"
                              error={!!errors.fullName}
                              helperText={errors.fullName?.message}
                              size="small"
                              sx={{ bgcolor: "#F5F7F9", borderRadius: "8px" }}
                            />
                          )}
                        />
                      </Grid>

                      <Grid className="col-md-4">
                        <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>
                          Date of Birth *
                        </Typography>
                        <Controller
                          name="dob"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              fullWidth
                              type="date"
                              error={!!errors.dob}
                              helperText={errors.dob?.message}
                              size="small"
                              sx={{ bgcolor: "#F5F7F9", borderRadius: "8px" }}
                            />
                          )}
                        />
                      </Grid>

                      <Grid className="col-md-4">
                        <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>
                          Gender *
                        </Typography>
                        <Controller
                          name="gender"
                          control={control}
                          render={({ field }) => (
                            <ReactSelect
                              {...field}
                              options={genderOptions}
                              onChange={(e) => field.onChange(e.value)}
                              value={genderOptions.find((option) => option.value === field.value)}
                              placeholder="Select..."
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  backgroundColor: "#F5F7F9",
                                  borderRadius: "8px",
                                  borderColor: errors.gender ? "#D32F2F" : "#E0E0E0",
                                }),
                              }}
                            />
                          )}
                        />
                        {errors.gender && (
                          <Typography sx={{ color: "#D32F2F", fontSize: "0.75rem", mt: 0.5 }}>
                            {errors.gender.message}
                          </Typography>
                        )}
                      </Grid>


                    </Grid>
                  </Box>

                  {/* Contact Information Card */}
                  <Box
                    sx={{
                      bgcolor: "#FFFFFF",
                      p: 3,
                      borderRadius: "12px",
                      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
                      mb: 4,
                    }}
                  >
                    <Typography
                      sx={{ fontWeight: "bold", color: "#2B7B7E", mt: 2 }}
                    >
                      Contact Information
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid className="row">
                        <Grid className="col-md-4">
                          <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>
                            Email *
                          </Typography>
                          <Controller
                            name="email"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                fullWidth
                                placeholder="Enter email"
                                error={!!errors.email}
                                helperText={errors.email?.message}
                                size="small"
                                sx={{ bgcolor: "#F5F7F9", borderRadius: "8px" }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid className="col-md-4">
                          <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>
                            Contact Number
                          </Typography>
                          <Controller
                            name="contactNo"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                fullWidth
                                placeholder="Enter contact number"
                                error={!!errors.contactNo}
                                helperText={errors.contactNo?.message}
                                size="small"
                                sx={{ bgcolor: "#F5F7F9", borderRadius: "8px" }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid className="col-md-4">
                          <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>
                            Address *
                          </Typography>
                          <Controller
                            name="address"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                fullWidth
                                placeholder="Enter address"
                                error={!!errors.address}
                                helperText={errors.address?.message}
                                size="small"
                                sx={{ bgcolor: "#F5F7F9", borderRadius: "8px" }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid className="col-md-4">
                          <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>
                            Street
                          </Typography>
                          <Controller
                            name="street"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                fullWidth
                                placeholder="Enter street"
                                error={!!errors.street}
                                helperText={errors.street?.message}
                                size="small"
                                sx={{ bgcolor: "#F5F7F9", borderRadius: "8px" }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid className="col-md-4">
                          <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>
                            City *
                          </Typography>
                          <Controller
                            name="city"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                fullWidth
                                placeholder="Enter city"
                                error={!!errors.city}
                                helperText={errors.city?.message}
                                size="small"
                                sx={{ bgcolor: "#F5F7F9", borderRadius: "8px" }}
                              />
                            )}
                          />
                        </Grid>

                        <Grid className="col-md-4">
                          <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>
                            State *
                          </Typography>
                          <Controller
                            name="state"
                            control={control}
                            render={({ field }) => (
                              <ReactSelect
                                {...field}
                                options={stateOptions}
                                onChange={(e) => field.onChange(e.value)}
                                value={stateOptions.find((option) => option.value === field.value)}
                                placeholder="Select..."
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    backgroundColor: "#F5F7F9",
                                    borderRadius: "8px",
                                    borderColor: errors.state ? "#D32F2F" : "#E0E0E0",
                                  }),
                                }}
                              />
                            )}
                          />
                          {errors.state && (
                            <Typography sx={{ color: "#D32F2F", fontSize: "0.75rem", mt: 0.5 }}>
                              {errors.state.message}
                            </Typography>
                          )}
                        </Grid>



                        <Grid className="col-md-4">
                          <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>
                            Zip Code *
                          </Typography>
                          <Controller
                            name="zipCode"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                fullWidth
                                placeholder="Enter zip code"
                                error={!!errors.zipCode}
                                helperText={errors.zipCode?.message}
                                size="small"
                                sx={{ bgcolor: "#F5F7F9", borderRadius: "8px" }}
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>

                  {/* Account Settings Card */}
                  <Box
                    sx={{
                      bgcolor: "#FFFFFF",
                      p: 3,
                      borderRadius: "12px",
                      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
                      mb: 4,
                    }}
                  >
                    <Typography
                      sx={{ fontWeight: "bold", color: "#2B7B7E", mb: 3 }}
                    >
                      Account Settings
                    </Typography>
                    {loadingPractices ? (
                      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                        <CircularProgress sx={{ color: "#2B7B7E" }} />
                      </Box>
                    ) : (
                      <Grid container spacing={3}>
                        <Grid className="row">
                          <Grid className="col-md-4">
                            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mb: 0.5 }}>
                              User Name *
                            </Typography>
                            <Controller
                              name="userName"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  fullWidth
                                  placeholder="Enter user name"
                                  error={!!errors.userName}
                                  helperText={errors.userName?.message}
                                  size="small"
                                  sx={{ bgcolor: "#F5F7F9", borderRadius: "8px" }}
                                />
                              )}
                            />
                          </Grid>

                          <Grid className="col-md-4">
                            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>
                              User Type *
                            </Typography>
                            <Controller
                              name="userType"
                              control={control}
                              render={({ field }) => (
                                <ReactSelect
                                  {...field}
                                  options={userTypeOptions}
                                  onChange={(e) => field.onChange(e.value)}
                                  value={userTypeOptions.find((option) => option.value === field.value) || null}
                                  placeholder="Select..."
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      backgroundColor: "#F5F7F9",
                                      borderRadius: "8px",
                                      borderColor: errors.userType ? "#D32F2F" : "#E0E0E0",
                                    }),
                                  }}
                                />
                              )}
                            />
                            {errors.userType && (
                              <Typography sx={{ color: "#D32F2F", fontSize: "0.75rem", mt: 0.5 }}>
                                {errors.userType.message}
                              </Typography>
                            )}
                          </Grid>

                          <Grid className="col-md-4">
                            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>
                              Password *
                            </Typography>
                            <Controller
                              name="password"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  fullWidth
                                  type="password"
                                  placeholder="Enter password"
                                  error={!!errors.password}
                                  helperText={errors.password?.message}
                                  size="small"
                                  sx={{ bgcolor: "#F5F7F9", borderRadius: "8px" }}
                                />
                              )}
                            />
                          </Grid>

                          <Grid className="col-md-4">
                            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>
                              Confirm Password *
                            </Typography>
                            <Controller
                              name="confirmPassword"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  fullWidth
                                  type="password"
                                  placeholder="Confirm password"
                                  error={!!errors.confirmPassword}
                                  helperText={errors.confirmPassword?.message}
                                  size="small"
                                  sx={{ bgcolor: "#F5F7F9", borderRadius: "8px" }}
                                />
                              )}
                            />
                          </Grid>

                          <Grid className="col-md-4">
                            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>
                              Default Practice *
                            </Typography>
                            <Controller
                              name="defaultpracticeId"
                              control={control}
                              render={({ field }) => (
                                <ReactSelect
                                  value={defaultPracticeOptions.find((option) => option.value === field.value) || null}
                                  onChange={(e) => {
                                    setPracticeId(e.value);
                                    field.onChange(e.value);
                                  }}
                                  options={defaultPracticeOptions}
                                  placeholder="Select..."
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      backgroundColor: "#F5F7F9",
                                      borderRadius: "8px",
                                      borderColor: errors.defaultpracticeId ? "#D32F2F" : "#E0E0E0",
                                    }),
                                  }}
                                />
                              )}
                            />
                            {errors.defaultpracticeId && (
                              <Typography sx={{ color: "#D32F2F", fontSize: "0.75rem", mt: 0.5 }}>
                                {errors.defaultpracticeId.message}
                              </Typography>
                            )}
                          </Grid>

                          <Grid className="col-md-4">
                            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>
                              Default Facility *
                            </Typography>
                            <Controller
                              name="defaultFacilityId"
                              control={control}
                              render={({ field }) => (
                                <ReactSelect
                                  {...field}
                                  options={facilityOptions}
                                  onChange={(e) => field.onChange(e.value)}
                                  value={facilityOptions.find((option) => option.value === field.value)}
                                  placeholder="Select..."
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      backgroundColor: "#F5F7F9",
                                      borderRadius: "8px",
                                      borderColor: errors.defaultFacilityId ? "#D32F2F" : "#E0E0E0",
                                    }),
                                  }}
                                />
                              )}
                            />
                            {errors.defaultFacilityId && (
                              <Typography sx={{ color: "#D32F2F", fontSize: "0.75rem", mt: 0.5 }}>
                                {errors.defaultFacilityId.message}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </Box>
                </Grid>
              </Grid>
              {/* Save and Cancel Buttons */}
              <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end", gap: 2 }}>
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  startIcon={<CancelOutlinedIcon />}
                  sx={{
                    bgcolor: "#77A2A7",
                    color: "#FFFFFF",
                    borderRadius: "12px",
                    textTransform: "none",
                    px: 4,
                    py: 1,
                    "&:hover": { bgcolor: "#5A7B7E" },
                  }}
                  disabled={isSubmitting}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<SaveOutlinedIcon />}
                  sx={{
                    bgcolor: "#2B7B7E",
                    color: "#FFFFFF",
                    borderRadius: "12px",
                    textTransform: "none",
                    px: 4,
                    py: 1,
                    "&:hover": {
                      bgcolor: "#195C5F",
                      boxShadow: "0 6px 16px rgba(0, 0, 0, 0.15)",
                    },
                  }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? <CircularProgress size={20} sx={{ color: "#FFFFFF" }} /> : "Save"}
                </Button>
              </Box>
            </TabPanel>

            <TabPanel value="practices" sx={{ p: 0 }}>
              <Box
                sx={{
                  bgcolor: "#FFFFFF",
                  p: 3,
                  borderRadius: "12px",
                  boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
                }}
              >
                {loadingPractices ? (
                  <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                    <CircularProgress sx={{ color: "#2B7B7E" }} />
                  </Box>
                ) : (
                  <>
                    <Grid container spacing={3} sx={{ mb: 4 }}>
                      <Grid item xs={12} sm={5}>
                        <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mb: 0.5 }}>
                          Practice
                        </Typography>
                        <Controller
                          name="UserPractice"
                          control={control}
                          render={({ field }) => (
                            <ReactSelect
                              options={practiceOptions}
                              onChange={(selectedOption) => {
                                const value = selectedOption ? selectedOption.value : 0;
                                field.onChange(value);
                                setUserPractice(value);
                                setPracticeId(value);
                                setPracticeIdError(false);
                                setDuplicateError(false);
                              }}
                              value={practiceOptions.find((option) => option.value === field.value) || null}
                              placeholder="Select..."
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  backgroundColor: "#F5F7F9",
                                  borderRadius: "8px",
                                  borderColor: practiceIdError || duplicateError ? "#D32F2F" : "#E0E0E0",
                                  minWidth: "100%",
                                }),
                                menu: (base) => ({
                                  ...base,
                                  width: "300px",
                                  zIndex: 9999,
                                }),
                                menuList: (base) => ({
                                  ...base,
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                }),
                                option: (base) => ({
                                  ...base,
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                }),
                              }}
                            />
                          )}
                        />
                        {practiceIdError && (
                          <Typography sx={{ color: "#D32F2F", fontSize: "0.75rem", mt: 0.5 }}>
                            Please select a practice!
                          </Typography>
                        )}
                        {duplicateError && (
                          <Typography sx={{ color: "#D32F2F", fontSize: "0.75rem", mt: 0.5 }}>
                            Practice already added! Please select another.
                          </Typography>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mb: 0.5 }}>
                          Provider
                        </Typography>
                        <Controller
                          name="provider_id"
                          control={control}
                          render={({ field }) => (
                            <ReactSelect
                              value={providerOptions.find((option) => option.value === field.value) || null}
                              onChange={(selectedOption) => {
                                const value = selectedOption ? selectedOption.value : 0;
                                setUserProvider(value);
                                setProviderIdError(false);
                                field.onChange(value);
                              }}
                              options={providerOptions}
                              placeholder="Select..."
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  backgroundColor: "#F5F7F9",
                                  borderRadius: "8px",
                                  borderColor: providerIdError ? "#D32F2F" : "#E0E0E0",
                                  minWidth: "100%",
                                }),
                                menu: (base) => ({
                                  ...base,
                                  width: "250px",
                                  zIndex: 9999,
                                }),
                              }}
                            />
                          )}
                        />
                        {providerIdError && (
                          <Typography sx={{ color: "#D32F2F", fontSize: "0.75rem", mt: 0.5 }}>
                            Please select a provider!
                          </Typography>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={3} sx={{ display: "flex", alignItems: "flex-end" }}>
                        <Button
                          onClick={handleUserPractice}
                          variant="contained"
                          startIcon={<AddOutlinedIcon />}
                          sx={{
                            bgcolor: "#2B7B7E",
                            color: "#FFFFFF",
                            borderRadius: "80px",
                            textTransform: "none",
                            fontWeight: 500,
                            px: 3,
                            py: 1,
                            width: "100%",
                            "&:hover": {
                              bgcolor: "#195C5F",
                              boxShadow: "0 6px 16px rgba(0, 0, 0, 0.15)",
                            },
                          }}
                          disabled={submitting}
                        >
                          Add Practice
                        </Button>
                      </Grid>
                    </Grid>
                    {rows.length === 0 ? (
                      <Typography sx={{ color: "#77A2A7", textAlign: "center", py: 4 }}>
                        No practices added yet.
                      </Typography>
                    ) : (
                      <DataGrid
                        autoHeight
                        rows={rows}
                        columns={columns}
                        pageSize={5}
                        rowsPerPageOptions={[5, 10, 25]}
                        sx={gridRowStyle}
                      />
                    )}
                  </>
                )}
              </Box>
            </TabPanel>
          </Box>
        </TabContext>
      </Box>
    </Container>
  );
};

export default UserRegistration;